type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'FinancialMovimentTypeGroup'
const nameSource = 'financial/financialMovimentsTypesGroups'
const namePageTitle = 'Tipos de Movimentações'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Tipos de Movimentações',
  to: '/financial/financialMovimentsTypesGroups',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/financial/financialMovimentsTypesGroups/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/financial/financialMovimentsTypesGroups/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/financial/financialMovimentsTypesGroups/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
